import { DeleteRequest } from '../../service/model/common/request/delete-request';
import { HotelRule } from './hotel-rule';
import { HotelRuleSearchCriteria } from './hotel-rule-search-criteria';

export const HOTEL_RULE_DELETE_REQUEST_VERSION = '1.0';

export interface HotelRuleCreateRequest {
  version: string;
  rule: HotelRule;
}

export interface HotelRuleSearchRequest {
  version: string;
  rule: HotelRuleSearchCriteria;
  searchFollowUpRequest?: {
    requestedPageNumber: string;
    numberOfRecords: string;
  };
}

export interface HotelRuleDeleteRequest extends DeleteRequest {
  rule: {
    version: number;
    id?: string;
    name?: string;
  };
}

export interface HotelUpdateRequest {
  version: string;
  rule: HotelRule;
}
